import { PARAMETER_TYPE } from './constant';
import { parseParam } from './index';

export const Result = function () {

}

Result.prototype.get = function () {
  return this.value;
}

Result.prototype.set = function (value) {
  this.value = value;
}

Result.prototype.callFunction = async function (body, customParamsList, customFunctionParams, instanceId) {
  if (body.length > 0) {
    if (this.value || this.value === 0) {
      let func = body[0];
      // console.log("callFunction------------------->>>>>", func);
      if (func.inParams) {
        func.inParams = [{
          paramType: PARAMETER_TYPE.FIXED,
          value: this.value
        }, ...func?.inParams];
        // 标记上一个函子传递过来的入参
        func["hasPrevious"] = true
      }
    }
    if (body.length === 1) {
      return (await parseParam(body[0], customParamsList, customFunctionParams, instanceId));
    } else {
      let result = new Result();
      result.set(await parseParam(body[0], customParamsList, customFunctionParams, instanceId));
      // 移除并返回数组的第一个元素
      body.shift();
      return await result.callFunction(_cloneDeep(body), customParamsList, customFunctionParams, instanceId);
    }
  }
}
